export default function React_JSXIntro() {
  return (
    <div>
      <h1>React_JSXIntro Component</h1>
      <p>This is the React_JSXIntro tutorial page.</p>
    </div>
  );
}
